import { PropsWithChildren } from 'react'
import { useTranslation } from 'next-i18next/pages'
import { LayoutProps } from './types'
import Footer from 'components/footer/Footer'
import { useStoreSelector } from 'hooks/store'
import Seo from 'components/seo/Seo'
import SimulationTypeToggle from './simulation-type-toggle/SimulationTypeToggle'
import PageHeader from 'components/page-header/PageHeader'
import styles from './Layout.module.scss'

const Layout = ({
  hideHeader,
  hideFooter,
  localized,
  children,
  seo,
  simulationSalesOffice,
  extraStartSimulationAction,
  highContrast
}: PropsWithChildren<LayoutProps>) => {
  // Redux store
  const { resetButton, partnerID, simulationType } = useStoreSelector((store) => store.marketing)

  // i18n
  const { t } = useTranslation(['seo', 'common'])

  return (
    <div className={styles.layout}>
      {/* SEO */}
      <Seo title={seo?.title || t(($) => $.commonSeoTitle)} {...seo} />

      {!hideHeader && <PageHeader {...{ localized, extraStartSimulationAction, highContrast, simulationSalesOffice }} />}

      {children}

      {partnerID && (resetButton || simulationType.length > 1) && <SimulationTypeToggle />}

      {!hideFooter && <Footer />}
    </div>
  )
}

Layout.defaultProps = {
  hideHeader: false
}

export default Layout
